export enum OptionEnum {
    NONE = "NONE",
    EQ = "EQ",
    GT = "GT",
    LT = "LT",
    RANGE = "RANGE"
}